// item actions
export const GET_ITEMS = 'GET_ITEMS';
export const ADD_ITEM = 'ADD_ITEM';
export const DELETE_ITEM = 'DELETE_ITEM';
export const UPDATE_ITEM = 'UPDATE_ITEM';

export const SET_CURRENT = 'SET_CURRENT';
export const CLEAR_CURRENT = 'CLEAR_CURRENT';

export const CLEAR_ITEMS = 'CLEAR_ITEMS';

export const ERROR_GET_ITEMS = 'ERROR_GET_ITEMS';
export const ERROR_ADD_ITEM = 'ERROR_ADD_ITEM';
export const ERROR_DELETE_ITEM =  'ERROR_DELETE_ITEM';
export const ERROR_UPDATE_ITEM =  'ERROR_UPDATE_ITEM';

// add item modal actions
export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';

// show loading actions
export const SHOW_LOADING = 'SHOW_LOADING';
export const HIDE_LOADING = 'HIDE_LOADING';

// notification messages actions
export const SUCCESS_MESSAGE = 'SUCCESS_MESSAGE';
export const ERROR_MESSAGE = 'ERROR_MESSAGE';
export const INFO_MESSAGE = 'INFO_MESSAGE';

//user actions
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT_FAIL = "LOGOUT_FAIL";
export const VISIT_GITHUB = 'VISIT_GITHUB';
export const VISIT_GITHUB_FAIL = 'VISIT_GITHUB_FAIL';

export const REGISTER_FAIL = 'REGISTER_FAIL';
export const SEND_EMAIL_RESET_PASSWORD_FAIL = 'SEND_EMAIL_RESET_PASSWORD_FAIL';
export const PASSWORD_RESET_FAIL = 'PASSWORD_RESET_FAIL';

export const SET_AUTH = 'SET_AUTH';
export const LOGOUT = 'LOGOUT';

export const CLEAR_MESSAGES = 'CLEAR_MESSAGES';



